<div class="dropdown">
    <a class="btn btn-file btn-exportIssuer" data-toggle="dropdown" disabled="isEmpty" [attr.id]="viewCode">
        {{documents.length}}
        <img src="{{Constant.icon_files}}" title="Tài liệu bổ sung">
    </a>
    <!-- show document -->
    <div class="dropdown-menu box-downloads" [attr.aria-labelledby]="viewCode">
        <span class="dropdown-arrow" style="left: auto; right: 5px;"></span>
        <div class="d-flex justify-content-center" *ngIf="profileId">
            <button class="btn btn-light mb-3 w-100" (click)="exportIdCard()">Export File
            </button>
        </div>
        <div class="father-items mb-2" *ngFor="let document of documents">
            <button class="btn btn-print">
                <img [src]="document.icon || './assets/images/icon/image-icon.png'" width="24" alt="">
            </button>
            <a class="dropdown-item" [href]="document.url" *ngIf="document.type !== 'PHOTO' && !document.photoType">
                {{document.fileName}}
            </a>
            <a class="dropdown-item" *ngIf="document.type === 'PHOTO' || document.photoType"
                (click)="showPhoto(document)">
                {{document.fileName}}
            </a>
            <a class="dropdown-item down-item" [href]="document.url">
                <img src="./assets/images/icon/ic-download.png" title="Tải về">
            </a>
        </div>
    </div>
</div>